function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 15"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8 1.6c.2.1.3.2.4.4l5.8 10c.3.5.1 1.1-.4 1.4-.2.1-.3.1-.5.1H1.7c-.6 0-1-.4-1-1 0-.2 0-.3.1-.5L6.6 2c.3-.5.9-.7 1.4-.4zm-.5.9l-5.8 10h11.5l-5.7-10zm0 7c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5S7 11.3 7 11v-1c0-.3.2-.5.5-.5zm0-4c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5S7 8.3 7 8V6c0-.3.2-.5.5-.5z"
})));